import React from 'react';
import FixedButton from "./FixedButton";

const FixedPanel=(props)=>(
    <div className='horizontal-flex-container'>
        {props.data.map((item)=>(<FixedButton id={item.id} src={item.src} srcOn={item.srcOn} key={item.id} handler={item.handler}/>))}
    </div>
);

export default FixedPanel;